import type {
  HTTPMessageType,
  HTTPRequest,
  HTTPResponse,
} from '@carboncopyco/types';
import { useState } from 'react';
import { RulesContent } from '../../../RulesManager';
import { useCopy } from '../../../hooks';
import type { Transaction } from '../../types';
import { BodyContent } from './BodyContent';
import { HeadersContent } from './HeadersContent';
import {
  type TransactionContent,
  transactionContentToLabel,
} from './TransactionContentFilter';
import { TransactionPreview } from './TransactonPreview';

export interface TransactionListItemProps {
  transaction: Transaction;
  onClick?: () => void;
  open?: boolean;
  selected?: boolean;
  searchValue?: string;
}

const transactionContentToComponent: Record<
  TransactionContent,
  React.FC<{
    message: HTTPRequest | HTTPResponse;
    onChange?: (value: string) => void;
    searchValue?: string;
  }>
> = {
  responseBody: BodyContent,
  requestBody: BodyContent,
  responseHeaders: HeadersContent,
  requestHeaders: HeadersContent,
};

const transactionContentToMessageType: Record<
  TransactionContent,
  HTTPMessageType
> = {
  responseBody: 'response',
  requestBody: 'request',
  responseHeaders: 'response',
  requestHeaders: 'request',
};

export const TransactionListItem = ({
  transaction,
  onClick,
  open,
  selected,
  searchValue,
}: TransactionListItemProps) => {
  const [transactionContent, setTransactionContent] =
    useState<TransactionContent>('responseBody');
  const [formattedContent, setFormattedContent] = useState<string>();
  const { copyText } = useCopy();

  const ContentComponent = transactionContentToComponent[transactionContent];
  const messageType = transactionContentToMessageType[transactionContent];

  return (
    <RulesContent.List.Item
      id={transaction.id}
      disabled={false}
      selected={selected}
      onClick={onClick}
      header={
        <TransactionPreview
          searchValue={searchValue}
          transaction={transaction}
          open={open}
          onTransactionContentChange={setTransactionContent}
          copyTransactionContent={() =>
            copyText(
              formattedContent,
              `${transactionContentToLabel[transactionContent]} copied to your clipboard.`
            )
          }
        />
      }
      content={
        <div className="border rounded-md overflow-hidden">
          <ContentComponent
            message={transaction.original[messageType]}
            onChange={setFormattedContent}
            searchValue={searchValue}
          />
        </div>
      }
    />
  );
};
